export default __webpack_public_path__ + "static/media/Zodiac-lucky-Number.30ddab61.jpg";